import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Departamento, Dispositivo } from '../../api.service';

@Component({
  selector: 'app-grade-terminais-relogio',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './grade-terminais-relogio.component.html'
})
export class GradeTerminaisRelogioComponent {
  @Input() terminais: Dispositivo[] = [];
  @Input() departamentos: Departamento[] = [];

  @Output() editar = new EventEmitter<Dispositivo>();
  @Output() revogar = new EventEmitter<Dispositivo>();

  nomesDepartamentos(terminal: Dispositivo) {
    if (!terminal.departamentoIds?.length) {
      return 'Todos';
    }
    const nomes = this.departamentos
      .filter(departamento => terminal.departamentoIds?.includes(departamento.id || ''))
      .map(departamento => departamento.nome);
    return nomes.length ? nomes.join(', ') : `${terminal.departamentoIds.length} departamento(s)`;
  }
}
